import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";


// Event_Map_By_Id
export const getEventMapById = async (EventId) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.EVENT_MAP_BY_ID_API}?eventId=${EventId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//Event_Map_Update
export const updateEventMap = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true,true));
    const response = await axioClient.post(
      apiendpoints.EVENT_MAP_UPDATE_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// Event_Map_ADD
export const addEventMap = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true, true));
    const response = await axioClient.post(
      apiendpoints.EVENT_MAP_ADD_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};


// export const setMapId = (id) => {
//   localStorage.setItem("id", id);
// };

// export const getMapId = () => {
//   const id = localStorage.getItem("id");
//   if (id !== null && id !== undefined) {
//     return id;
//   } else {
//     return null;
//   }
// };
// export const removeMapId = () => {
//   localStorage.removeItem("id");
// };